<div class="row">
    <div class="col-md-12 text-end">
        <h3 class="organization_title mt-5">
            Organization Name <span>{{ currentOrganizationName }}</span>
        </h3>
    </div>
</div>

<div class="row" style="width: 100%; margin: 10px 0px" *ngIf="instanceForm">
    <div class="col-md-2">
        <mat-label class="font-style-title">Add logo</mat-label>

        <div class="profile_label">
            <div class="project-logo-wrapper">
                <span *ngIf="imageUrl == null && !instanceForm.get('instance_name').value"
                    class="mdi mdi-image-search profile-image-instance" id="profile_image_instance"
                    (click)="imageUpload.click()"></span>
                <img *ngIf="imageUrl != null" [src]="imageUrl" class="profile-image" id="profile_image_instance"
                    (click)="imageUpload.click()" />
                <div class="avatar-container">
                    <div *ngIf="!imageUrl && instanceForm.get('instance_name').value">
                        <ngx-avatars [name]="instanceForm.value.instance_name" initialsSize="3" size="150"
                            bgColor="#ffcc01" fgColor="#010101"></ngx-avatars>
                    </div>
                </div>
                <div class="icon-wrapper">
                    <div class="edit-icon" (click)="imageUpload.click()">
                        <mat-icon>edit</mat-icon>
                    </div>
                    <div class="delete-icon" *ngIf="imageUrl != null">
                        <mat-icon (click)="deleteSelectedImage()">delete</mat-icon>
                    </div>
                </div>
            </div>
            <input id="fileInput" accept="image/*" (click)="imageUpload.value = null" type="file"
                (change)="onSelectFile($event)" #imageUpload style="display: none" />
        </div>
    </div>
    <div class="col-md-10">
        <form [formGroup]="instanceForm" *ngIf="isFormControlInitialized">
            <mat-label class="font-style form-section-heading mb-8"><b>Instance Details</b></mat-label>
            <div class="row mt-4 mb-4">
                <div class="col-md-3">
                    <mat-label class="font-style">Instance Name</mat-label>
                    <mat-form-field class="example-full-width custom-text-field instance-name" [floatLabel]="'never'">
                        <input type="text" matInput placeholder="Enter instance name here" name="instance_name"
                            formControlName="instance_name" [readonly]="isEditEnabled === false"
                            (keypress)="onKeyPress($event)" (paste)="onKeyPress($event)" [ngClass]="{
    'invalid-field': instanceForm.get('instance_name')?.invalid 
  }" />
                    </mat-form-field>
                </div>
                <div class="col-md-3">
                    <mat-label class="font-style">Instance Type</mat-label>
                    <mat-select name="instance_type" placeholder="Select Instance type" class="dropdown-wrapper"
                        panelClass="dropdown-wrapper" formControlName="instance_type" *ngIf="instanceTypes"
                        [class.disbleDrop-down]="instanceDetails?.instanceId || disableInstanceType">
                        <mat-option class="option-list" value="{{ type.instanceTypeId }}"
                            *ngFor="let type of instanceTypes">{{ type.name }}</mat-option>
                    </mat-select>
                </div>
            </div>
            <div class="row mt-4 mb-4">
                <div class="col-md-3">
                    <mat-label class="font-style">Asset Type</mat-label>
                    <mat-select name="asset_type" placeholder="Select asset type"
                        [class.disbleDrop-down]="instanceDetails?.instanceId || disableAssetsType"
                        class="dropdown-wrapper" panelClass="dropdown-wrapper" formControlName="instance_assetType"
                        (selectionChange)="assetTypeChange($event)" *ngIf="assetTypes"
                        [ngClass]="instanceForm.get('instance_assetType').invalid && isNextButtonClicked ? 'errorDropDown' : ''"
                        required>
                        <mat-option class="option-list" value="{{ type.instanceAssetTypeId }}"
                            *ngFor="let type of assetTypes">{{ type.name }}</mat-option>
                    </mat-select>
                </div>
                <div class="col-md-3">
                    <mat-label class="font-style">Instance Context</mat-label>
                    <mat-select name="instance_context" placeholder="Select Instance Context" class="dropdown-wrapper"
                        panelClass="dropdown-wrapper" formControlName="instance_context" *ngIf="contextTypes"
                        [ngClass]="instanceForm.get('instance_context').invalid && isNextButtonClicked ? 'errorDropDown' : ''">
                        <mat-option class="option-list" value="{{ instanceContext.instanceContextId }}"
                            *ngFor="let instanceContext of contextTypes" [disabled]="isEditEnabled === false">{{
                            instanceContext.name }}</mat-option>
                    </mat-select>
                </div>
            </div>
            <div class="row mt-4 mb-4">
                <div class="col-md-12">
                    <div class="row">
                        <div class="col-md-3">
                            <mat-label class="font-style">Start Date</mat-label>
                            <dx-date-box class="dx-date-custom-wrapper" [value]="now"
                                formControlName="instance_startDate" displayFormat="dd-MMM-yyyy"
                                [inputAttr]="{ 'aria-label': 'Select Start Date' }" [disabled]="isEditEnabled === false"
                                blockDateTyping>
                            </dx-date-box>
                            <!-- Added 'blockDateTyping' directive to block typing  in dx-datepicker -->
                        </div>
                        <div class="col-md-3">
                            <mat-label class="font-style">End Date</mat-label>
                            <dx-date-box class="dx-date-custom-wrapper" [value]="now" formControlName="instance_endDate"
                                displayFormat="dd-MMM-yyyy" [inputAttr]="{ 'aria-label': 'Select End Date' }"
                                [disabled]="isEditEnabled === false" blockDateTyping>
                            </dx-date-box>
                            <!-- Added 'blockDateTyping' directive to block typing  in dx-datepicker -->
                        </div>
                        <div class="col-md-3">
                            <mat-label class="font-style">Notes</mat-label>
                            <mat-form-field class="example-full-width custom-text-field" [floatLabel]="'never'">
                                <input type="text" matInput placeholder="Enter additional notes here"
                                    formControlName="instance_notes" name="notes" [readonly]="isEditEnabled === false"
                                    (keypress)="onKeyPress($event)" (paste)="onKeyPress($event)" />
                            </mat-form-field>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mt-5">
                <mat-label class="font-style form-section-heading"><b>Contact Details</b></mat-label>
                <div class="row mt-4 mb-4">
                    <div class="col-md-3">
                        <mat-label class="font-style">First Name</mat-label>
                        <mat-form-field class="example-full-width custom-text-field" [floatLabel]="'never'">
                            <input type="text" matInput placeholder="Enter first name here"
                                formControlName="contact_firstName" name="contact_name" readonly
                                (keypress)="onKeyPress($event)" (paste)="onKeyPress($event)" />
                        </mat-form-field>
                    </div>
                    <div class="col-md-3">
                        <mat-label class="font-style">Last Name</mat-label>
                        <mat-form-field class="example-full-width custom-text-field" [floatLabel]="'never'">
                            <input type="text" matInput placeholder="Enter last name here"
                                formControlName="contact_lastName" name="contact_name" readonly />
                        </mat-form-field>
                    </div>
                    <div class="col-md-3">
                        <mat-label class="font-style"> Email</mat-label>
                        <mat-form-field class="example-full-width custom-text-field" [floatLabel]="'never'">
                            <input type="email" matInput placeholder="Enter contact email here"
                                formControlName="contact_email" readonly />
                        </mat-form-field>
                    </div>
                    <div class="col-md-3">
                        <button type="button" class="btn primary-ebtn" (click)="openUserModal()"
                            [disabled]="isEditEnabled === false">Select Contact</button>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>